<template>
  <div>
    <v-row justify="center" class="vb-subscription">
      <v-col class="col-md-4 col-sm-12">
        <v-card elevation=0 class="mb-4">
          <div class="subscription-header">
            <div class="subscription-title">{{$t('menus.subscriptions.bronze')}}</div>
            <div class="subscription-price" v-if="subscriptionPeriod.bronze === 'month'">€{{ bronzeMonthlyPrice }}</div>
            <div class="subscription-price" v-if="subscriptionPeriod.bronze === 'year'">€{{ bronzeAnnuallyPrice }}</div>
            <div class="subscription-price-clarification">{{$t('menus.subscriptions.pricePerUserExVAT')}}</div>


            <div class="subscription-buttons">
              <v-btn
                  v-bind:class="bronzeMonthlyClass"
                  @click="changePeriod('bronze', 'month')"
                  class="mr-2"
                  elevation=0
              >
                {{$t('menus.subscriptions.monthly')}}
              </v-btn>
              <v-btn
                  v-bind:class="bronzeAnnuallyClass"
                  @click="changePeriod('bronze', 'year')"
                  elevation=0
              >
                {{$t('menus.subscriptions.annually')}}
              </v-btn>
            </div>


            <div class="subscription-included-per-user">{{$t('menus.subscriptions.includedPerUser')}}</div>
          </div>

          <v-list class="vb-bg-fix">
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.namedClientUser', 1) }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.unlimitedClientAndProjectFolders') }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.unlimitedReviewUploadLinks') }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.storageGB', 50) }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.nOutboundData', 10) }}

            </v-list-item>

            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.AICredits', 250) }}

            </v-list-item>
          </v-list>

          <div v-if="!canManageActiveSubscription">
            <div class="mb-2">
              <v-text-field
                type="text"
                v-bind:model-value="bronzeUsers"
                v-bind:label="$t('menus.resourceLimits.quantity')"
                append-icon="mdi-plus-circle-outline"
                v-on:click:append="increment('bronzeUsers')"
                prepend-icon="mdi-minus-circle-outline"
                v-on:click:prepend="decrement('bronzeUsers')"
                hide-details
                readonly
                variant="solo-filled" flat
                density="compact"
              ></v-text-field>
            </div>

            <v-sheet v-if="bronzeUsers > 0" elevation="0" color="secondary" rounded class="my-2 px-2 text-center">
              <div>
                {{$t('menus.subscriptions.nSubscriptions', bronzeUsers)}}
              </div>
              <div v-if="subscriptionPeriod.bronze === 'month'">
                € {{ bronzeUsers * Number(bronzeMonthlyPrice)}} {{$t('menus.subscriptions.perMonth')}}
              </div>
              <div v-if="subscriptionPeriod.bronze === 'year'">
                € {{ bronzeUsers * Number(bronzeAnnuallyPrice)}} {{$t('menus.subscriptions.perYear')}}
              </div>
            </v-sheet>

            <div class="d-flex justify-center align-center">
              <v-btn
                @click="subscribe('bronze', 'bronzeUsers')"
                v-bind:disabled="newSubscriptionNotAllowed || bronzeUsers == 0"
                color="primary"
                elevation=0
              >
                {{$t('common.subscribe')}}
              </v-btn>
            </div>
          </div>

          <div v-if="canManageActiveSubscription && getSubscriptionName === 'bronze'" class="d-flex justify-center align-center">
            <v-btn
            v-bind:href="stripeUrl"
            target="_blank"
            class="bg-primary"
            elevation=0
            >
              {{$t('menus.subscriptions.managePlan')}}
            </v-btn>
          </div>

        </v-card>
      </v-col>

      <v-col class="col-md-4 col-sm-12">
        <v-card elevation=0 border class="sub-recommended">
          <div class="subscription-header">
            <div class="subscription-title">
              {{$t('menus.subscriptions.silver')}}
              <!-- <v-chip color="green">{{$t('menus.subscriptions.recommended')}}</v-chip> -->
            </div>
            <div class="subscription-price" v-if="subscriptionPeriod.silver === 'month'">€{{ silverMonthlyPrice }}</div>
            <div class="subscription-price" v-if="subscriptionPeriod.silver === 'year'">€{{ silverAnnuallyPrice }}</div>
            <div class="subscription-price-clarification" style="color: #FFFFFF;">{{$t('menus.subscriptions.pricePerUserExVAT')}}</div>

            <div class="subscription-buttons">
              <v-btn
                v-bind:class="silverMonthlyClass"
                @click="changePeriod('silver', 'month')"
                class="mr-2"
                elevation=0
              >
                {{ $t('menus.subscriptions.monthly') }}
              </v-btn>
              <v-btn
                v-bind:class="silverAnnuallyClass"
                @click="changePeriod('silver', 'year')"
                elevation=0
              >
                {{ $t('menus.subscriptions.annually') }}
              </v-btn>
            </div>

            <div class="subscription-included-per-user" style="color: #FFFFFF;">{{$t('menus.subscriptions.includedPerUser')}}</div>
          </div>

          <v-list>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.namedClientUser', 1) }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.unlimitedClientAndProjectFolders') }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.unlimitedReviewUploadLinks') }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.storageGB', 75) }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.nOutboundData', 15) }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.AICredits', 500) }}

            </v-list-item>
          </v-list>

          <div v-if="!canManageActiveSubscription">
            <div class="mb-2">
              <v-text-field
                type="text"
                v-bind:model-value="silverUsers"
                v-bind:label="$t('menus.resourceLimits.quantity')"
                append-icon="mdi-plus-circle-outline"
                v-on:click:append="increment('silverUsers')"
                prepend-icon="mdi-minus-circle-outline"
                v-on:click:prepend="decrement('silverUsers')"
                hide-details
                readonly
                variant="solo-filled" flat
                density="compact"
              ></v-text-field>
            </div>

            <v-sheet v-if="silverUsers > 0" elevation="0" color="secondary" rounded class="my-2 px-2 text-center">
              <div>
                {{$t('menus.subscriptions.nSubscriptions', silverUsers)}}
              </div>
              <div v-if="subscriptionPeriod.silver === 'month'">
                € {{ silverUsers * Number(silverMonthlyPrice)}} {{$t('menus.subscriptions.perMonth')}}
              </div>
              <div v-if="subscriptionPeriod.silver === 'year'">
                € {{ silverUsers * Number(silverAnnuallyPrice)}} {{$t('menus.subscriptions.perYear')}}
              </div>
            </v-sheet>

            <div class="d-flex justify-center align-center">
              <v-btn
                  @click="subscribe('silver', 'silverUsers')"
                  v-bind:disabled="newSubscriptionNotAllowed || silverUsers == 0"
                  color="primary"
                  elevation=0
              >{{$t('common.subscribe')}}</v-btn>
            </div>
          </div>

          <div v-if="canManageActiveSubscription && getSubscriptionName === 'silver'" class="d-flex justify-center align-center">
            <v-btn
            v-bind:href="stripeUrl"
            target="_blank"
            class="bg-primary"
            elevation=0
            >
              {{$t('menus.subscriptions.managePlan')}}
            </v-btn>
          </div>
        </v-card>
      </v-col>

      <v-col class="col-md-4 col-sm-12">
        <v-card elevation=0>
          <div class="subscription-header">
            <div class="subscription-title">{{$t('menus.subscriptions.gold')}}</div>
            <div class="subscription-price" v-if="subscriptionPeriod.gold === 'month'">€{{ goldMonthlyPrice }}</div>
            <div class="subscription-price" v-if="subscriptionPeriod.gold === 'year'">€{{ goldAnnuallyPrice }}</div>
            <div class="subscription-price-clarification">{{$t('menus.subscriptions.pricePerUserExVAT')}}</div>

            <div class="subscription-buttons">
              <v-btn
                v-bind:class="goldMonthlyClass"
                @click="changePeriod('gold', 'month')"
                class="mr-2"
                elevation=0
              >
                {{ $t('menus.subscriptions.monthly') }}
              </v-btn>
              <v-btn
                v-bind:class="goldAnnuallyClass"
                @click="changePeriod('gold', 'year')"
                elevation=0
              >
                {{ $t('menus.subscriptions.annually') }}
              </v-btn>
            </div>

            <div class="subscription-included-per-user">{{$t('menus.subscriptions.includedPerUser')}}</div>
          </div>

          <v-list class="vb-bg-fix">
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.namedClientUser', 1) }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.unlimitedClientAndProjectFolders') }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.unlimitedReviewUploadLinks') }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.storageGB', 100) }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.nOutboundData', 20) }}

            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-check-circle</v-icon>
              </template>

              {{ $t('menus.subscriptions.AICredits', 750) }}

            </v-list-item>
          </v-list>

          <div v-if="!canManageActiveSubscription">
            <div class="mb-2">
              <v-text-field
                type="text"
                v-bind:model-value="goldUsers"
                v-bind:label="$t('menus.resourceLimits.quantity')"
                append-icon="mdi-plus-circle-outline"
                v-on:click:append="increment('goldUsers')"
                prepend-icon="mdi-minus-circle-outline"
                v-on:click:prepend="decrement('goldUsers')"
                hide-details
                readonly
                variant="solo-filled" flat
                density="compact"
              ></v-text-field>
            </div>

            <v-sheet v-if="goldUsers > 0" elevation="0" color="secondary" rounded class="my-2 px-2 text-center">
              <div>
                {{$t('menus.subscriptions.nSubscriptions', goldUsers)}}
              </div>
              <div v-if="subscriptionPeriod.gold === 'month'">
                € {{ goldUsers * Number(goldMonthlyPrice)}} {{$t('menus.subscriptions.perMonth')}}
              </div>
              <div v-if="subscriptionPeriod.gold === 'year'">
                € {{ goldUsers * Number(goldAnnuallyPrice)}} {{$t('menus.subscriptions.perYear')}}
              </div>
            </v-sheet>

            <div class="d-flex justify-center align-center">
              <v-btn  @click="subscribe('gold', 'goldUsers')"
                      v-bind:disabled="newSubscriptionNotAllowed || goldUsers == 0"
                      color="primary"
                      elevation=0
              >{{$t('common.subscribe')}}</v-btn>
            </div>
          </div>

          <div v-if="canManageActiveSubscription && getSubscriptionName === 'gold'" class="d-flex justify-center align-center">
            <v-btn
            v-bind:href="stripeUrl"
            target="_blank"
            class="bg-primary"
            elevation=0
            >
              {{$t('menus.subscriptions.managePlan')}}
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>


    <v-row >
      <v-col>
        <h2 class="mt-4 ml-4">{{$t('menus.subscriptions.addons')}}</h2>
        <v-card elevation=0 class="vb-subscription">
          <v-row class="addons-header">
            <v-col>
              &nbsp;
            </v-col>
            <v-col>
              {{$t('menus.subscriptions.bronze')}}
            </v-col>
            <v-col>
              {{$t('menus.subscriptions.silver')}}
            </v-col>
            <v-col>
              {{$t('menus.subscriptions.gold')}}
            </v-col>
          </v-row>

          <v-row class="addons-row" v-for="item in addons" :key="item.name" v-bind:class="{ 'addon-group': item.group }">
            <v-col>
              {{ $t(`menus.subscriptions.${item.name}`) }}
            </v-col>
            <v-col v-if="!item.group">
              {{ item.bronze }}
            </v-col>
            <v-col v-if="!item.group">
              {{ item.silver }}
            </v-col>
            <v-col v-if="!item.group">
              {{ item.gold }}
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h2 class="mt-4 ml-4">{{$t('menus.subscriptions.mainFeatures')}}</h2>
        <v-card elevation=0 class="vb-subscription">
          <v-row class="addons-header">
            <v-col>
              &nbsp;
            </v-col>
            <v-col>
              {{$t('menus.subscriptions.bronze')}}
            </v-col>
            <v-col>
              {{$t('menus.subscriptions.silver')}}
            </v-col>
            <v-col>
              {{$t('menus.subscriptions.gold')}}
            </v-col>
          </v-row>

          <v-row class="addons-row" v-for="feature in features" :key="feature.name">
            <v-col>
              {{ $t(`menus.subscriptions.${feature.name}`) }}
            </v-col>
            <v-col>
              <v-icon v-if="feature.bronze">mdi-check-circle</v-icon>
              <span v-else>&nbsp;</span>
            </v-col>
            <v-col>
              <v-icon v-if="feature.silver">mdi-check-circle</v-icon>
              <span v-else>&nbsp;</span>
            </v-col>
            <v-col>
              <v-icon v-if="feature.gold">mdi-check-circle</v-icon>
              <span v-else>&nbsp;</span>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>


    <v-row>
      <v-col>
        <v-card elevation=0 class="vb-subscription enterprise">
          <v-card-title>{{ $t('menus.subscriptions.enterpriseSolutions')}}</v-card-title>

          <v-card-subtitle>{{ $t('menus.subscriptions.customMadeOffers')}}</v-card-subtitle>
          <v-card-text>
            {{ $t('menus.subscriptions.please')}} <a href="mailto:sales@tubeway.io" target="_blank">{{ $t('menus.subscriptions.contactUs')}}</a> {{ $t('menus.subscriptions.ifHaveSpecialRequests')}}.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useSystemStore } from '@/stores/SystemStore.js'
import { useTenantStore } from '@/stores/TenantStore.js'

export default {
  name: "SubscriptionPlansIndex",
  data() {
    return {

      bronzeUsers: 0,
      silverUsers: 0,
      goldUsers: 0,
      stripeUrl: null,

      subscriptionPeriod: {
        bronze: "month",
        silver: "month",
        gold: "month",
      },

      subBtnDisabled: false,

      addons: [
        { name: 'users', bronze: '', silver: '', gold: '', group: true },
        { name: 'fullAccessClientUser', bronze: '€ 12,-', silver: '€ 9,-', gold: '€ 6,-' },
        { name: 'storageBandwidth', bronze: '', silver: '', gold: '', group: true },
        { name: '250GBstorage', bronze: '€ 12,50', silver: '€ 12,50', gold: '€ 12,50' },
        { name: '50GBOutboundData', bronze: '€ 12,50', silver: '€ 12,50', gold: '€ 12,50' },
        { name: 'AIServices', bronze: '', silver: '', gold: '', group: true },
        { name: '250Credits', bronze: '€ 8,-', silver: '€ 6,-', gold: '€ 4,-' },
      ],

      features: [
        { name: 'unlimitedClientFolders', bronze: true, silver: true, gold: true },
        { name: 'unlimitedProjects', bronze: true, silver: true, gold: true },
        { name: 'unlimitedExternalLinks', bronze: true, silver: true, gold: true },
        { name: 'sharingMediaFiles', bronze: true, silver: true, gold: true },
        { name: 'frameAccurateComments', bronze: true, silver: true, gold: true },
        { name: 'searchableLabelsMetadata', bronze: true, silver: true, gold: true },
        { name: 'adobePremierFinalCutProExtensions', bronze: true, silver: true, gold: true },
        { name: 'automatedTranscriptsSubtitlesTranslations', bronze: true, silver: true, gold: true },
        { name: 'AIGeneratedObjectTextShot', bronze: true, silver: true, gold: true },
        { name: 'transcodingDistributionTools', bronze: true, silver: true, gold: true },
        { name: 'detailedUsageReports', bronze: true, silver: true, gold: true },
        { name: 'limitCommentsFoldersTeamOnly', bronze: false, silver: true, gold: true },
        { name: 'brandedPortal', bronze: false, silver: false, gold: true }
      ],
    };
  },
  afterCreate() {
    if (!this.$canControlTenantConfig()) {
      this.$router.push('/console/index');
    }


    if (this.isRecurringSubscription(this.subscriptionType)) {
      this.$router.push('/console/index');
    }
  },
  watch: {
    canManageActiveSubscription: function(newValue) {
      if (newValue) {
        this.refreshStripeURL();
      } else {
        this.stripeUrl = null;
      }
    },
    subscriptionType(newType) {
      if (this.isRecurringSubscription(newType)) {
        this.$router.push('/console/index');
      }
    }
  },

  async mounted() {
    // If the user object is not available, fetch it from the database
    if (!this.dbUser) {
      const authStore = useAuthStore();
      try {
        await authStore.refreshDBUser();

        if (!this.$canControlTenantConfig()) {
          this.$router.push('/console/index');
          return;
        }

        if (this.isRecurringSubscription(this.subscriptionType)) {
          this.$router.push('/console/index');
          return;
        }


        if (this.canManageActiveSubscription) {
          this.refreshStripeURL();
        }
      } catch (error) {
        console.error('Error refreshing DB user:', error);
        this.$showMessage(this.$t('backend.system-error'), { type: 'error' });
      }
    } else {
      if (this.canManageActiveSubscription) {
        this.refreshStripeURL();
      }
    }
  },
  methods: {
    isRecurringSubscription(type) {
      const tenantStore = useTenantStore();
      return tenantStore.getRecurringSubscriptionTypes.includes(type);
    },
    changePeriod(type, period) {
      this.subscriptionPeriod[type] = period;
    },
    subscribe: function(plan, quantityVariableName) {
      let self = this;
      this.errorMessage = "";

      this.subBtnDisabled = true;

      const payload = {
        contextNodeId: this.accessPointId,
        body: {}
      }

      const subscriptionInterval = this.subscriptionPeriod[plan];

      const product = this.findProduct(plan, subscriptionInterval);
      payload.body[product.id] = this[quantityVariableName];

      const systemStore = useSystemStore();
      systemStore.subscribeForPlan(payload)
        .then(function(response) {
          if (response && response.data && response.data.url) {
            window.location = response.data.url;
          }
        })
        .catch(function(error) {
          if (error && error.response && error.response.data && error.response.data.error) {
            const localizedMessage = self.$localizeMessage(error.response.data.error, self.$t('backend.system-error'));
            self.$showMessage(localizedMessage, { type: 'error' });
          } else {
            console.log(error);
            self.$showMessage(self.$t('backend.system-error'), { type: 'error' });
          }
        });
    },

    findProduct(plan, interval) {
      let product = null;

      const productNameForSearch = plan.toLowerCase();

      if (this.subscriptionPlans && this.subscriptionPlans.length > 0) {
        for (const subscriptionPlan of this.subscriptionPlans) {
          const productName = subscriptionPlan.product.name.toLowerCase();

          if (productName === productNameForSearch) {
            if (subscriptionPlan.prices
                && Array.isArray(subscriptionPlan.prices)
                && subscriptionPlan.prices.length > 0)
            {
              product = subscriptionPlan.prices.find(x => x.interval === interval);
              break;
            }
          }
        }
      }

      return product;
    },

    refreshStripeURL: function () {
      let self = this;

      const systemStore = useSystemStore();
      systemStore.manageSubscriptionUrl(this.accessPointId)
        .then(function (response) {
          if (response && response.data && response.data.url) {
            self.stripeUrl = response.data.url;
          }
        })
        .catch(function (error) {
          self.stripeUrl = null;

          if (error && error.response && error.response.data && error.response.data.error) {
            const localizedMessage = self.$localizeMessage(error.response.data.error, self.$t('backend.system-error'));
            self.$showMessage(localizedMessage, { type: 'error' });
          } else {
            console.log(error);
            self.$showMessage(self.$t('backend.system-error'), { type: 'error' });
          }
        });
    },
    increment(variableName) {
      this[variableName] += 1;
    },
    decrement(variableName) {
      if (this[variableName] > 0) {
        this[variableName] -= 1;
      }
    },
  },
  computed: {
    user: function() {
      const authStore = useAuthStore();
      return authStore.dbUser;
    },
    bronzeMonthlyClass() {
      return this.subscriptionPeriod.bronze === "month" ? "primary" : "sub-secondary";
    },
    bronzeAnnuallyClass() {
      return this.subscriptionPeriod.bronze === "year" ? "primary" : "sub-secondary";
    },
    silverMonthlyClass() {
      return this.subscriptionPeriod.silver === "month" ? "primary" : "sub-secondary";
    },
    silverAnnuallyClass() {
      return this.subscriptionPeriod.silver === "year" ? "primary" : "sub-secondary";
    },
    goldMonthlyClass() {
      return this.subscriptionPeriod.gold === "month" ? "primary" : "sub-secondary";
    },
    goldAnnuallyClass() {
      return this.subscriptionPeriod.gold === "year" ? "primary" : "sub-secondary";
    },
    bronzeMonthlyPrice() {
      const product = this.findProduct('Bronze', 'month');
      return product ? (product.price / 100).toFixed(0) : null;
    },
    bronzeAnnuallyPrice() {
      const product = this.findProduct('Bronze', 'year');
      return product ? (product.price / 100).toFixed(0) : null;
    },
    silverMonthlyPrice() {
      const product = this.findProduct('Silver', 'month');
      return product ? (product.price / 100).toFixed(0) : null;
    },
    silverAnnuallyPrice() {
      const product = this.findProduct('Silver', 'year');
      return product ? (product.price / 100).toFixed(0) : null;
    },
    goldMonthlyPrice() {
      const product = this.findProduct('Gold', 'month');
      return product ? (product.price / 100).toFixed(0) : null;
    },
    goldAnnuallyPrice() {
      const product = this.findProduct('Gold', 'year');
      return product ? (product.price / 100).toFixed(0) : null;
    },
    accessPointId: function() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    subscription: function() {
      const systemStore = useSystemStore();
      return systemStore.getSubscription;
    },
    getSubscriptionName() {
      if (this.subscription &&
          this.subscription.subscription &&
          this.subscription.subscription.name &&
          typeof this.subscription.subscription.name === 'string') {
        return this.subscription.subscription.name.toLowerCase();
      }

      return null;
    },
    subscriptionPlans: function() {
      if (this.subscription && this.subscription.plans) {
        return Object.values(this.subscription.plans);
      }

      return null;
    },
    canManageActiveSubscription: function() {
      const hasActiveSubscription = this.subscription && this.subscription.addons && Object.keys(this.subscription.addons).length > 0;
      return this.$canControlTenantConfig() && hasActiveSubscription;
    },
    newSubscriptionNotAllowed: function() {
      return this.canManageActiveSubscription || this.subBtnDisabled;
    },
    tenantNodeId: function() {
      const authStore = useAuthStore();
      return authStore.getAccessPointIds[0];
    },
    subscriptionTypes: function() {
      const tenantStore = useTenantStore();
      return tenantStore.getSubscriptionTypes;
    },
    subscriptionType: function() {
      const authStore = useAuthStore();
      const activeTenant = authStore.getActiveTenant;

      if (activeTenant?.subscription?.subscriptionType) {
        return activeTenant.subscription.subscriptionType;
      }

      return null;
    },
  }
}
</script>

<style>
.vb-subscription .v-card {
  padding: 1rem;
}

.vb-subscription .subscription-header {
  margin-left: 1rem;
  margin-top: 1rem;
  text-align: center;
}

.vb-subscription .subscription-title {
  font-size: 1.7rem;
  letter-spacing: .2rem;
  font-weight: bold;
  text-transform: uppercase;
}

.vb-subscription .subscription-price {
  font-size: 6rem;
}

.vb-subscription .subscription-price-clarification {
  font-weight: 600;
  margin-bottom: 16px;
}

.vb-subscription .subscription-included-per-user {
  font-weight: 600;
  margin-top: 20px;
}

.vb-subscription .v-icon.mdi-check-circle {
  color: #3dabff;
}

.vb-subscription .v-list-item__content {
  margin-left: 1rem;
}

.vb-subscription .subscription-buttons {
  padding: .5rem;
  border-radius: 10px;
  display: inline-block;
  font-size: 1.2rem;
  font-weight: bold;
}

.vb-subscription .sub-recommended,
.vb-subscription .sub-recommended  .v-list {
  background-color: black !important;
  border-color: #3dabff;
}

.vb-subscription .addons-header {
  background-color: #3dabff;
  color: black;
  font-size: 1rem;
  margin-top: 20px;

  margin-left: 0;
  margin-right: 0;
}

.vb-subscription .addons-row {
  padding: 0 16px;
  margin: 12px 0 0 0;
}
.v-theme--dark .addons-row {
  border-bottom: #14171b  solid 1px;
}
.v-theme--light .addons-row {
  border-bottom: #e6ecf1  solid 1px;
}

.vb-subscription .addon-group {
  font-size: 1.5em;
  font-weight: bold;
}

.v-theme--dark .v-list.vb-bg-fix {
  background-color: #232b36 !important;
}

.v-theme--dark .vb-subscription .subscription-buttons {
  background-color: black;
}

.v-theme--light .vb-subscription .subscription-buttons {
  background-color: #e8e8e8;
}

.v-theme--light .vb-subscription .sub-recommended .subscription-buttons {
  background-color: #212121;
}

.v-theme--light .vb-subscription .v-btn.sub-secondary {
  background-color: #f5f5f5;
  color: black;
}

.v-theme--light .sub-recommended .subscription-price,
.v-theme--light .sub-recommended .v-list-item__content {
  color: white !important;
}

.sub-recommended .subscription-title {
  color: #3dabff;
}

.vb-subscription.enterprise .v-card__title {
  font-weight: bold !important;
  font-size: 1.7rem !important;
  padding-top: 1.7em !important;
}

.vb-subscription.enterprise .v-card__title + .v-card__subtitle {
  margin-top: 10px;
  font-size: 1.2em;
}

.v-theme--light .vb-subscription.enterprise .v-card__title {
  color: black !important;
}

.vb-subscription.enterprise .v-card__text {
  font-size: 1em;
}

</style>
